import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

// Reuses the same component as the Google Step 3; the screen reads
// `location.pathname` to decide which platform context (retry connection,
// source label, back/retry-redirect targets) applies.
const CompleteImportScreen = lazy(
  () => import('~/features/onboarding/pages/complete-import-screen'),
);

/** `workflowId` is emitted by Step 2 after triggering the sync — passing it as
 *  a search param (rather than in a store) means a hard-refresh of Step 3
 *  still resumes polling the same workflow. Optional so the screen can render
 *  an empty/error state when hit directly without a prior trigger. */
const searchSchema = z.object({
  workflowId: z.string().optional(),
});

function MetaCompleteImportRouteComponent() {
  const { workflowId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      {/* Pass the route's own path so the platform context never reads a stale
          `location.pathname` mid-navigation. */}
      <CompleteImportScreen
        workflowId={workflowId}
        routePathname="/onboarding/integration/meta/complete-import"
      />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/meta/complete-import',
)({
  validateSearch: searchSchema,
  component: MetaCompleteImportRouteComponent,
});
